import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import KhaltiCheckout from "khalti-checkout-web";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import ErrorDialog from "../ErrorDialog/ErrorDialog";

import { url } from "../../config/config";
import KhaltiLogo from "../../Assets/Images/khalti.png";

class CustomerKhaltiPay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      message: "",
    };
  }

  handleSuccess = async (payload) => {
    if (this.props.rent === true) {
      try {
        let data = {};
        data = {
          orderId: this.props.productIdentity,
          payVia: this.props.payType,
          khaltiId: payload.mobile,
          paymentId: payload.idx,
          totalPrice: this.props.total,
          amount: payload.amount,
          bookId: this.props.bookId,
          rentedDays: parseInt(this.props.rentedDays),
          token: payload.token,
          itemDetails: [
            {
              bookId: this.props.bookId,
              title: this.props.productName,
              price: this.props.total,
            },
          ],
        };
        const response1 = await Axios.post(`${url}/api/rent`, data, {
          headers: {
            "x-auth-token": this.props.userToken,
          },
        });
        if (response1.data.success) {
          this.props.history.push(`/myrentedbooks`);
        }
      } catch (error) {
        if (error.response.data.errorMessage) {
          this.setState({
            error: true,
            message: error.response.data.errorMessage,
          });
        }
      }
    } else {
      try {
        let data = {};
        if (this.props.itemDetails.length !== 0) {
          let newArray = this.props.itemDetails.map((book) => {
            return {
              bookId: book.id._id,
              title: book.id.title,
              price: book.id.price,
            };
          });
          data = {
            orderId: this.props.productIdentity,
            payVia: this.props.payType,
            khaltiId: payload.mobile,
            paymentId: payload.idx,
            totalPrice: this.props.total,
            amount: payload.amount,
            bookId: this.props.bookId,
            rentedDays: parseInt(this.props.rentedDays),
            token: payload.token,
            itemDetails: newArray,
          };
        } else {
          data = {
            orderId: this.props.productIdentity,
            payVia: this.props.payType,
            khaltiId: payload.mobile,
            paymentId: payload.idx,
            bookId: this.props.bookId,
            totalPrice: this.props.total,
            amount: payload.amount,
            token: payload.token,
            itemDetails: [
              {
                bookId: this.props.bookId,
                title: this.props.productName,
                price: this.props.total,
              },
            ],
          };
        }
        const response = await Axios.post(`${url}/api/sold`, data, {
          headers: {
            "x-auth-token": this.props.userToken,
          },
        });
        if (response.data.success) {
          if (this.props.itemDetails.length !== 0) {
            this.props.clearCart();
            this.props.history.push("/cart");
          }
          this.props.history.push("/mybooks/Customer");
        }
      } catch (error) {
        if (error.response.data.errorMessage) {
          this.setState({
            error: true,
            message: error.response.data.errorMessage,
          });
        }
      }
    }
  };

  handleError = (error) => {
    console.log(error.response);
  };

  handleClose = () => {
    console.log("Closing");
  };

  productIdentity = this.props.productIdentity;
  productName = this.props.productName;
  productUrl = this.props.productUrl;

  config = {
    publicKey: "test_public_key_5742f13ea76b482d85be2abb6c027b10",
    productIdentity: this.productIdentity,
    productName: this.productName,
    productUrl: this.productUrl,
    paymentPreference: ["KHALTI"],
    eventHandler: {
      onSuccess: this.handleSuccess,
      onError: this.handleError,
      onClose: this.handleClose,
    },
  };

  checkout = new KhaltiCheckout(this.config);

  handlePay = (total) => {
    this.checkout.show({ amount: total * 100 }); //Rs.1 = 100 paisa
  };

  render() {
    return (
      <div>
        <Button
          onClick={() => this.handlePay(this.props.total)}
          className={this.props.classes}
          disabled={this.props.disabled}
        >
          <img
            src={KhaltiLogo}
            alt="khalti"
            style={{ width: 150, height: 60 }}
          />
        </Button>
        {this.state.error === true && (
          <ErrorDialog
            message={this.state.message}
            url={this.props.reloadUrl}
          />
        )}
      </div>
    );
  }
}

export default withRouter(CustomerKhaltiPay);
